const DELTA_THRESHOLD = 5;
const TOP_GUARD_PX = 80;

// Mirror image of scroll-hide-listener.ts's navbar behavior: that one hides
// the navbar on the way down (it's already visible at rest) and shows it on
// the way up. This button starts hidden (so it never sits in the way of a
// short page) and only appears once the visitor is actively reading down the
// page, where a quick "ask us" escape hatch is actually useful.
export function bindFloatingChatScroll(button: HTMLElement): void {
    let lastY = window.scrollY;

    window.addEventListener(
        "scroll",
        () => {
            const currentY = window.scrollY;
            const delta = currentY - lastY;

            if (Math.abs(delta) < DELTA_THRESHOLD) return;

            if (currentY <= TOP_GUARD_PX) {
                button.classList.remove("is-scroll-visible");
                lastY = currentY;
                return;
            }

            const scrollingDown = delta > 0;
            button.classList.toggle("is-scroll-visible", scrollingDown);

            lastY = currentY;
        },
        { passive: true },
    );
}
